<template>
  <div class="primary-input-container">
    <p v-if="label_name || name" class="pimary-input-title">
      {{ label_name || name }}
    </p>
    <span v-if="items">Selected - {{ items }}</span>
    <div class="primary-select-wrapper">
      <select
        :value="value"
        :placeholder="placeholder"
        :name="name"
        :disabled="disabled"
        ref="sel"
        @focus="evn ? ($refs.sel.size = 8) : null"
        @blur="evn ? ($refs.sel.size = 1) : null"
        @change="
          evn ? ($refs.sel.size = 1) : $emit('input', $event.target.value)
        "
      >
        <option v-if="placeholder" value="" disabled selected class="placeholder">{{placeholder}}</option>
        <slot />
        <option selected="selected" disabled v-if="select"></option>
        <option
          v-for="(option, index) in options"
          :key="index"
          :value="option.value"
        >
          {{ option.name }}
        </option>
      </select>
      <!-- :selected="option.value==selectOption ? true : ''" -->
      <div v-if="value && isCross" class="clear-selected" @click="$emit('input', '')">
        <x-circle-icon size="1.2x" class="custom-class clear-icon"></x-circle-icon>

      </div>
      <img src="../../assets/Icon/Arrow/Down.svg" class="icon-down" alt />

      <!-- <multiselect :value="value"
                  :name="name"
                  :disabled="disabled"
                  v-model="selected"
                  @input="handleSelect"
                  :options="options"
                  :multiple="false"
                  :allow-empty="false"
                  :selectLabel="''"
                  :deselectLabel="''"
                  :closeOnSelect="true"
                  :show-labels="false"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder=""
                  label="name"
                  track-by="value"
                  :preselect-first="true">
        <template slot="selection"
                  slot-scope="{ values, search, isOpen, option }">
          <span class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"> selected
          </span>
        </template>
      </multiselect>-->
    </div>
  </div>
</template>

<script>
  import { XCircleIcon } from 'vue-feather-icons'

  export default {
  props: {
    value: {},
    placeholder: {},
    options: {},
    name: {},
    disabled: {},
    label_name: {},
    items: {},
    evn: {},
    select: {},
    selectOption: {},
    isCross: {
      default: true,
    },
  },
  data: () => ({
  }),    selected: null,

    components: {
      XCircleIcon
    },
  computed: {

    checkedOprtions() {
      return this.options.map((i) => ({ removable: false, ...i }));
    },
  },

  methods: {
    handleSelect(e) {
      this.$emit("input", e ? e.value : null);
    },
  },
};
</script>

<style lang="scss" scoped>
  .clear-selected {
    position: absolute;
    right: 36px;
    cursor: pointer;
    transition: .2s;

    &:hover {
      transform: scale(1.2);
      transition: .2s;
    }
  }
* {
  box-sizing: border-box;
}
.primary-input-container {
  width: 100%;
  padding: 0;
  .pimary-input-title {
    width: 100%;
    color: #000000;
    font-family: "Helvetica Neue";
    font-size: 12px;
    font-weight: 900;
    letter-spacing: 0.21px;
    line-height: 15px;
    margin-bottom: 5px;
    text-transform: uppercase;
  }
  .primary-select-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: 40px;
    border: 1px solid #edeef3;
    border-radius: 4px;
    background-color: #ffffff;

    ::placeholder {
      color: #55616e;
    }
    select {
      -webkit-appearance: none; /* Webkit */
      -moz-appearance: none; /* FF */
      -ms-appearance: none; /* Edge */
      appearance: none; /* Future */

      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      padding-left: 15px;
      padding-right: 15px;
      font-family: "Helvetica Neue";
      font-size: 16px;
      line-height: 25px;
    }
    select:focus {
      border: 1px solid #51a3f3;
    }
    select::-ms-expand {
      display: none;
    }
    .icon-down {
      //position: absolute;
      position: absolute;
      top: 4px;
      left: 100%;
      margin-left: -35px;
      background: #fff;
      pointer-events: none !important;
    }
  }
}

  select {
    font-size: 14px !important;
    opacity: .9;
  }

  .clear-icon {
    color: #c9ccd8;
  }
</style>


